// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"3a46c673","125":"7944495f","154":"344bb4c3","222":"2527a88a","287":"3a299914","424":"eb46e713","511":"57558cde","749":"405e5da9","784":"20395715","829":"b6b50b4b","836":"dae808a3","930":"b0bb6409"}[chunkId] + ".chunk.js";
};